




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { FaxLine, ForwardingNumber } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveForwardingNumberPage extends Base {
  public phoneMask: string = '##########';
  public vehicleOptionsFields: Array<VFields<any>> = [];
  public vehicleOptionsModel: any = {
    id: '',
    description: '',
    fieldValue: '',
  };

  public storeId: number = 0;
  public form: any = {};
  public vehicleOptionId: string = '';

  public requestProgress: boolean = false;
  public vehicleOptionLoader: boolean = false;

  public vehicleOptionsList: any[] = [];
  public vehicleOptions: any[] = [];
  public templateFields: any[] = [];
  // ['Vin','Color','Trim','OrderedOn','TotalAmount','MsrpAmount', 'FirstName','LastName'];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'vehicleOptions' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveVehicleOptions();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public appendField(field: string): void {
    this.vehicleOptionsModel.fieldValue += `{${field}}`;
  }

  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    this.getVehicleOptionFields(this.storeId);
    if (this.$route.params.vehicleOptionsId) {
      this.vehicleOptionId = this.$route.params.vehicleOptionsId;
    }

    if (this.$route.params.storeId) {
      this.getStoreInfo();
    }

    this.setInvoiceFields(this.storeId);

    this.setvehicleOptionsFields();

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public async getVehicleOptionFields(storeId) {
    try {
      var response = await storeService.getVehicleOptionFields(storeId);
      var data = [];
      this.vehicleOptions = response.results;
      response.results.forEach((x) => {
        data.push(x.fieldDescription);
      });

      this.vehicleOptionsList = data;
    } finally {
      this.setvehicleOptionsFields();
    }
  }

  public setInvoiceFields(id) {
    // if (id == 17) {
    //   // Nissan
    //   this.templateFields = [
    //     'Vin',
    //     'Color',
    //     'Trim',
    //     'OrderedOn',
    //     'OrderNumber',
    //     'TotalAmount',
    //     'MsrpAmount',
    //     'FirstName',
    //     'LastName',
    //   ];
    // } else if (id == 2) {
    //   // BMW
    //   this.templateFields = [
    //     'Vin',
    //     'Color',
    //     'ColorCode',
    //     'ModelCode',
    //     'Cost',
    //     'MsrpAmount',
    //     'ProductionNumber',
    //     'SoldTo',
    //     'Trim',
    //     'TrimCode',
    //   ];
    // } else if (id == 7) {
    //   // subaru
    //   this.templateFields = [
    //     'Vin',
    //     'InvoiceNumber',
    //     'ModelCode',
    //     'ColorCode',
    //     'Color',
    //     'Trim',
    //     'List',
    //     'InvoiceCost',
    //     'HoldBack',
    //     'FloorPlan',
    //     'Cost',
    //     'EngineCode',
    //     'IgnitionKeyCode',
    //     'GrossWeight',
    //     'SoldTo',
    //   ];
    // }

    this.templateFields = [
      'Vin',
      'InvoiceNumber',
      'ModelCode',
      'ColorCode',
      'Color',
      'Trim',
      'List',
      'InvoiceCost',
      'HoldBack',
      'FloorPlan',
      'Cost',
      'EngineCode',
      'IgnitionKeyCode',
      'GrossWeight',
      'SoldTo',
      'OrderedOn',
      'OrderNumber',
      'TotalAmount',
      'FirstName',
      'LastName',
      'MsrpAmount',
      'ProductionNumber',
      'TrimCode',
      'BaseRetailAmount',
      'FloorplanAssistance',
      'DestinationAndDeliveryFee',
      'AZPlan',
      'DPlan',
      'XPlan',
    ];
  }

  public setvehicleOptionsFields(): void {
    this.vehicleOptionsFields = [
      {
        key: 'description',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: 'Description',
          required: true,
          text: 'name',
          value: 'fieldDescription',
          disabled: this.vehicleOptionId ? true : false,
          items: this.vehicleOptionsList,
          altag: 'Description',
          loading: false,
          rules: [
            v => this.required('Description', v)
          ]
        },
      },
      {
        key: 'fieldValue',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          label: 'Value',
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Value', v)
          ]
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.vehicleOptionLoader = true;
      this.formlyShowSkeleton(this.vehicleOptionsFields);
      const response = await storeService.getStore(this.storeId);
      const selectedvehicleOptions = response.storeJson.vehicleFieldJson.find(
        (m) => m.id === this.$route.params.vehicleOptionsId
      );

      if (this.vehicleOptionId) {
        this.vehicleOptionsModel.id = selectedvehicleOptions.id;
        this.vehicleOptionsModel.description =
          selectedvehicleOptions.description;
        this.vehicleOptionsModel.fieldValue = selectedvehicleOptions.fieldValue;
      }
    } finally {
      this.vehicleOptionLoader = false;
      this.formlyHideSkeleton(this.vehicleOptionsFields);
    }
  }

  public validateVehicleOptions(): Vue & { validate: () => boolean } {
    return this.$refs.vehicleOptionForm as Vue & { validate: () => boolean };
  }

  public async saveVehicleOptions(): Promise<void> {
    if (this.validateVehicleOptions().validate()) {
      try {
        this.requestProgress = true;

        this.$emit('update:progress', this.requestProgress);
        // var numbers = /^[0-9]+$/;
        // var types = ["N", "B", "C", "G"];
        var filteredData = this.vehicleOptions.filter(
          (x) => x.fieldDescription == this.vehicleOptionsModel.description
        )[0];

        if (this.vehicleOptionsModel.id === '') {
          await storeService.saveVehicleFields(
            this.storeId,
            this.vehicleOptionsModel
          );
          this.showAlert(true, 'Vehicle Fields Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tab: 'vehicleOptions'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updateVehicleFields(
            this.storeId,
            this.vehicleOptionsModel
          );
          this.showAlert(true, 'Vehicle Fields Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab: 'vehicleOptions'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
